<template>
  <div class="menu">
    <div class="menu__brand">
      <slot name="brand"></slot>
    </div>
    <ul v-if="!!$scopedSlots['item-structure']" :class="menuClasses">
      <li class="menu__items__item menu__items__item--mobile-button">
        <app-menu-mobile-button v-model="menuIsOpen"/>
      </li>
      <li class="menu__items__item" v-for="item in itemsList" :key="item._uuid">
        <slot name="item-structure" class="menu__items__item__link" v-bind:item="item"></slot>
      </li>
    </ul>
    <div class="menu__actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
import MenuMobileButton from './MobileButton.vue'
export default {
  name: 'AppMenu',
  status: 'prototype',
  release: '1.0.0',
  components: { MenuMobileButton },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      menuIsOpen: false
    }
  },
  computed: {
    menuClasses () {
      return {
        menu__items: 'menu__items',
        'menu__items--open': !!this.menuIsOpen
      }
    },
    itemsList () {
      return this.items.map((item, index) => {
        item._uuid = index
        return item
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
$padding-base: 15px;
.menu {
  @include reset();
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 22px;
  background-color: $color-purple;
  font-family: $font-text;
  color: $color-ice;
  @media #{$media-query-l} {
    padding: 22px 70px;
  }
  &__brand {
    flex-grow: 2;
    max-width: 150px;
    padding-top: 6px;
    padding-bottom: 6px;
    padding-right: $padding-base;
  }
  &__items {
    @include reset();
    display: block;
    height: 45px;
    padding: 10px 0;
    overflow: hidden;
    list-style: none;
    transition: width 0.5s cubic-bezier(0.77, 0.2, 0.05, 1);
    @media #{$media-query-l} {
      padding: 0 $padding-base 0 0;
    }
    @media #{$media-query-m} {
      display: flex;
      flex-direction: column;
      flex-grow: 5;
      flex-direction: row;
      flex-wrap: wrap;
      height: auto;
    }
    &--open {
      position: fixed;
      width: 100%;
      height: 100%;
      background-color: $color-purple;
      left: 0;
      top: 0;
      z-index: 9999;
    }
    &__item {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 40px;
      padding: 0 15px;
      @media #{$media-query-m} {
        height: auto;
        justify-content: flex-start;
      }
      &--mobile-button {
        height: 30px;
        @media #{$media-query-m} {
          display: none;
        }
      }
      & > a {
        font-family: inherit;
        font-size: $size-s;
        font-weight: 600;
        color: $color-purple-lighter;
        text-decoration: none;
        outline: none;
        &.menu__items_item--active,
        &:hover,
        &:focus {
          color: $color-ice;
        }
      }
    }
  }
  &__actions {
    display: flex;
    width: 100%;
    flex-direction: row;
    flex-grow: 5;
    justify-content: space-between;
    padding: 0;
    @media #{$media-query-m} {
      width: auto;
      padding-left: $padding-base;
      justify-content: flex-end;
    }
  }
}
</style>
